import React, { useCallback } from 'react';

import GoogleCalendarLogo from 'Shared/components/Logos/GoogleCalendarLogo';
import Outlook365Logo from 'Shared/components/Logos/Outlook365Logo';

import { WorkspaceMember, RecurringMeeting, RecurringMeetingSource } from 'Shared/constants/types';
import { sanitizeFullName } from 'Shared/helpers';

import './SyncMeetingsModalRecurringMeeting.scss';

type Props = {
  meeting: RecurringMeeting;
  teammates: Array<WorkspaceMember>;
  currentUserEmail: string;
  onSelectMeeting: Function;
};

function SyncMeetingsModalRecurringMeeting({ meeting, teammates, currentUserEmail, onSelectMeeting }: Props) {
  const getInfoWhoAttendees = useCallback(() => {
    const attendees = meeting.attendees.filter(
      ({ email }) =>
        email !== currentUserEmail && !teammates.find(({ email: teammateEmail }) => teammateEmail === email)
    );
    teammates
      .filter(({ email }) => meeting.attendees.find(({ email: attendeeEmail }) => attendeeEmail === email))
      .map(({ fullName, email }) => attendees.unshift({ email, fullName, displayName: email }));
    if (meeting.attendees.find(({ email }) => email === currentUserEmail))
      attendees.unshift({ email: currentUserEmail, fullName: 'You', displayName: 'You' });

    return `Attendees: ${attendees.map(({ email, fullName }) => sanitizeFullName(fullName) || email).join(' & ')}`;
  }, [meeting, currentUserEmail, teammates]);

  return (
    <div className="choose-meeting-modal-item border d-flex pl-2 pr-3 mb-2">
      {meeting.source === RecurringMeetingSource.google ? (
        <GoogleCalendarLogo className="choose-meeting-modal-item-logo--google" />
      ) : (
        <Outlook365Logo className="choose-meeting-modal-item-logo--outline365 m-1" />
      )}
      <div className="ml-2 font-weight-600">
        {meeting.name}
        <div className="choose-meeting-modal-item-attendees text-muted">{getInfoWhoAttendees()}</div>
      </div>
      <button
        type="button"
        className="btn btn-primary ml-auto py-1 px-4 align-self-start"
        onClick={() => onSelectMeeting(meeting)}
      >
        Select
      </button>
    </div>
  );
}

export default SyncMeetingsModalRecurringMeeting;
